import React, { useContext, useEffect } from 'react';
import { Flex, Button, Card, Typography, } from 'antd';

import { Course } from '../Course';
import _ from 'lodash';
import { semesterStruct } from './struct';
import { IsFormSaved } from '../../../../../../context/FromStatusContext';
import { useSelector } from 'react-redux';

const { Title, Paragraph } = Typography;

export const Semester = ({
  semesterDetail,
  updateSemester,
  // updated,
  // evaluatePlaning,
  updatePlaning,
  semesterLoading,
  status,
  semesterComments
}) => {
  const { setIsFormSaved } = useContext(IsFormSaved);

  const _static = useSelector((state) => state.static);
  const { staticData } = _static;

  const { evaluation_status: evaluationStatus } = staticData;

  // const [updated, setUpdated] = useState(false);

  const { semester, apa_point } = semesterDetail;
  const courses = semesterDetail?.data || [];

  useEffect(() => {

    const isEqual = _.isEqual(semesterDetail?.data, semesterDetail?.courses);

    if (isEqual) {
      setIsFormSaved(true);
      // setUpdated(false)
    } else {
      setIsFormSaved(false);
      // setUpdated(true)
    };
  }, [semesterDetail?.data, semesterDetail?.courses]);

  useEffect(() => {
    setIsFormSaved(true)
  }, []);



  return (
    <Card {...semesterStruct.wrapper}>
      <Flex {...semesterStruct.header}>
        <Title {...semesterStruct.title}>
          Semester~
          {semester === 1 ? 'Spring' : semester === 2 ? 'Summer' : semester === 3 ? 'Autumn' : ''}
        </Title>
        <Title {...semesterStruct.title}>
          Status~
          {evaluationStatus?.filter((e) => e.value === status)?.[0]?.label}
        </Title>
      </Flex>

      {semesterComments && semesterComments[semester] && (
        <Paragraph>
          <strong>Comment:</strong> {semesterComments[semester]}
        </Paragraph>
      )}

      <Course
        courses={courses}
        semesterName={semester}
        updateSemester={updateSemester}
        apaPoint={apa_point}
        status={status}
      />

      <Typography.Text
        type="secondary"
        style={{ display: 'block', marginTop: 8, fontSize: 12, color: '#27be6b' }}
      >
        <strong>Note:</strong><br />
        1. Save after every change <br />
        2. The form will be locked after end of evaluation period.
      </Typography.Text>

      {/* <br /> */}

      <Flex justify='end' gap={10}>
        <Button
          {...semesterStruct.saveButton}
          loading={semesterLoading[semester]?.updateLoading}
          onClick={() => updatePlaning(semester)}
          disabled={status === 1 || status === 2 || status === 3}
        >
          Save
        </Button>

        {/* <Button
          {...semesterStruct.evaluateButton}
          loading={semesterLoading[semester]?.evaluateLoading}
          onClick={() => evaluatePlaning(semester)}
          disabled={status === 1 || status === 2 || status === 3 || courses?.length === 0 }
        >
          {
            status === 1 || status === 2 || status === 3 ? 'Locked' : 'Lock'
          }
        </Button> */}

      </Flex>
    </Card>
  );
};
